// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"e8ba0a66","114":"2df47f70","124":"fe57a719","184":"d892a6d0","249":"427a43c0","253":"90806b96","260":"23d78a81","292":"038a7947","407":"c896cd3e","850":"c228baea","879":"97e062be"}[chunkId] + ".chunk.js";
};